export default from './pagination-comments';



// WEBPACK FOOTER //
// ./app/components/pagination-comments/index.js